angular.module('document')
    .component('documentSupervisedIco', {
        bindings: {
            supervised: '<',
            title: '@'
        },
        template: `
            <span ng-if="$ctrl.supervised" class="document-info-header" title="{{$ctrl.title}}">
                <i class="fa fa-fw fa-shield document-supervised"></i>
            </span>
        `
    })
